import React from 'react'

import {
  HiMiniChevronRight,
  HiOutlineBolt,
  HiOutlineCheckCircle,
} from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

interface SearchStep {
  value: string
  completed: boolean
}

export const LoadingStep: React.FC = () => {
  return (
    <div className="w-24 h-6 rounded-md bg-primary-200 dark:bg-primary-800 animate-pulse" />
  )
}

const SearchStep: React.FC<SearchStep> = ({ value, completed }) => {
  return (
    <div className="flex items-center max-w-full gap-x-1">
      <div
        className={twMerge(
          'flex items-center w-fit max-w-full overflow-ellipsis gap-2 rounded-[5px] py-[1px] px-[6px] border',
          completed
            ? // remaining 4% leaves room for the chevron below, only comes into play when the text is overflowing and the step is completed
              'max-w-[96%] text-primary-900 dark:text-primary-200 bg-primary-100 dark:bg-primary-600/20 border-primary-400 dark:border-primary-500'
            : 'animate-ripple text-accent-900 dark:text-accent-100 bg-accent-50 dark:bg-accent-600/20 border-accent-400 dark:border-accent-500',
        )}
      >
        <div className="flex items-center w-full gap-x-1">
          <div>
            {completed ? (
              <HiOutlineCheckCircle className="w-4 h-4" />
            ) : (
              <HiOutlineBolt className="w-4 h-4 text-accent-700 dark:text-accent-300" />
            )}
          </div>
          <span className="text-sm font-medium overflow-hidden text-ellipsis whitespace-nowrap">
            {value}
          </span>
        </div>
      </div>
      {completed && (
        <div>
          <HiMiniChevronRight className="w-4 h-4 text-primary-500 dark:text-primary-400" />
        </div>
      )}
    </div>
  )
}

export default SearchStep
